// Minimal HL7 v2 parser: splits a raw message into segments with named fields
// (MSH-1, PID-3, ...). Handles the MSH field-numbering quirk and duplicate
// segment names (OBX, OBX (2), ...).

export function parseHl7(raw) {
    if (!raw) return { segments: [], raw: '', encoding: {} };

    // Strip MLLP framing bytes if present.
    const text = String(raw).replace(/\x0b/g, '').replace(/\x1c/g, '');

    const lines = text
        .split(/\r\n|\r|\n/)
        .map(l => l.replace(/\s+$/,'').trim())
        .filter(l => l.length > 0);

    // Encoding characters from MSH.
    let fieldSep = '|';
    let compSep = '^';
    let repSep = '~';
    let subSep = '&';

    const mshLine = lines.find(l => l.startsWith('MSH'));
    if (mshLine && mshLine.length >= 4) {
        fieldSep = mshLine[3];
        const enc = mshLine.slice(4).split(fieldSep)[0] || '^~\\&';
        compSep = enc[0] || '^';
        repSep = enc[1] || '~';
        subSep = enc[3] || '&';
    }

    const nameCounts = {};

    const segments = lines.map((line) => {
        const parts = line.split(fieldSep);
        const name = parts[0];

        nameCounts[name] = (nameCounts[name] || 0) + 1;
        const occurrence = nameCounts[name];
        const label = occurrence > 1 ? `${name} (${occurrence})` : name;

        const fields = [];

        if (name === 'MSH') {
            // MSH-1 is the field separator itself, MSH-2 the encoding chars.
            fields.push({ key: 'MSH-1', value: fieldSep });
            for (let i = 2; i <= parts.length; i++) {
                fields.push({ key: `MSH-${i}`, value: parts[i - 1] ?? '' });
            }
        } else {
            for (let i = 1; i <= parts.length - 1; i++) {
                fields.push({ key: `${name}-${i}`, value: parts[i] ?? '' });
            }
        }

        // Attach component breakdown for fields that have them (skip MSH-1/MSH-2,
        // which are the separators/encoding chars themselves).
        fields.forEach(f => {
            if (f.key === 'MSH-1' || f.key === 'MSH-2') return;
            if (f.value && f.value.indexOf(compSep) !== -1) {
                f.components = f.value.split(compSep);
            }
        });

        return { name, label, fields, raw: line };
    });

    return { segments, raw: text, encoding: { fieldSep, compSep, repSep, subSep } };
}
